import React from 'react';

import Spinner from '../Spinner/Spinner';

const SpinnerMiddleware = ({ children, targetParameter, centered = false, color, height = '' }) => {
  if (!targetParameter)
    return (
      <div className={centered ? 'text-center' : ''} style={{ height }}>
        <Spinner backgroundColor={color} />
      </div>
    );
  return children;
};

export default SpinnerMiddleware;
